import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { filter } from 'rxjs';
import { PriceFacade } from '../facades/price.facade';

export const storePriceLoaded = (): CanActivateFn => {
    return (route: ActivatedRouteSnapshot) => {
        const priceFacade = inject(PriceFacade);
        priceFacade.getStorePrice(route.parent.params.storeId);

        return priceFacade.storePriceIsLoaded$.pipe(filter((loaded) => loaded === true));
    };
};
